/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type appGithub_viewer$ref: FragmentReference;
declare export opaque type appGithub_viewer$fragmentType: appGithub_viewer$ref;
export type appGithub_viewer = {|
  +id: string,
  +company: ?{|
    +id: string,
    +githubEnabled: ?boolean,
    +githubInstallationId: ?number,
    +githubUnauthorizedInstallation: ?number,
  |},
  +$refType: appGithub_viewer$ref,
|};
export type appGithub_viewer$data = appGithub_viewer;
export type appGithub_viewer$key = {
  +$data?: appGithub_viewer$data,
  +$fragmentRefs: appGithub_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appGithub_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "githubEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "githubInstallationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "githubUnauthorizedInstallation",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = '4b60a984904ac7c82293338561bf2837';

module.exports = node;
